import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) {
  }

  postPayment(data: any) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.baseURL + '/pay', data).subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }
}
